import application from 'application/application';

application

	.directive('ngIndeterminate', () => ({
		restrict: 'A',
		link(scope, element, attrs) {

			scope.$watch(attrs['ngIndeterminate'], value => element.prop('indeterminate', !!value));

		}
	}));
